import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function calendar(data) {
        return axios.get(`${endpoint}/calendar`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function updateDate(id, data) {
        return axios.post(`${endpoint}/${id}/update-date`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        calendar,
        updateDate
    }
}

export default service
